var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.isActive === true ? 'icon iconfont icon-suoxiao' : 'icon iconfont icon-fangda',on:{"click":_vm.toggleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }